import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthenticationService } from '../_services';
import { RouteNavigationService } from '../_services/routeNavigationService';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
        private routeNavService: RouteNavigationService,
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        return new Promise((resolve) => {
            const guestRoutes = [
                '/landing/',
                '/otherforms/testentrypages',
                '/payexapps/'
            ];
            const isGuestRoute = guestRoutes.find(guestRoute => state.url.indexOf(guestRoute) !== -1);
            if (isGuestRoute) {
                resolve(true);
            } else {
                this.authenticationService.getUserDataInSession().then((userData) => {
                    if (userData) {
                        const usrData = JSON.parse(userData);
                        if (route.data && route.data.checkAutoPull && (!usrData.auto_pull_allowed && !usrData.defermentViewByDayDC)) {
                            resolve(false);
                        } else {
                            const data = usrData.loginData || usrData.user_profile
                            if (!data || !usrData.loggedInTimeStamp) {
                                resolve(false);
                                this.routeNavService.navigateRoot('/signin', { queryParams: { returnUrl: state.url } });
                            } else {
                                if (usrData.loginData.user.eippSessionData.data.user.forcePinChange) {
                                    if (state.url.indexOf('/account/changepin') === -1) {
                                        this.routeNavService.navigateRoot('/account/changepin', { queryParams: { returnUrl: state.url } });
                                    }
                                }
                                resolve(true);
                            }
                        }
                    } else {
                        this.routeNavService.navigateRoot('/signin', { queryParams: { returnUrl: state.url } });
                        resolve(false);
                    }
                }).catch(err => {
                    resolve(false);
                });
            }
        });
    }
}
